// extracted by mini-css-extract-plugin
export var description = "full_width_image-module--description--1iqig";
export var excerpt = "full_width_image-module--excerpt--yFveZ";
export var fullWidthImage = "full_width_image-module--fullWidthImage--g6ND6";
export var image = "full_width_image-module--image--IKv8+";